/**
 * Resuelve src de banner/portada/galería: URL http(s), data URI, base64 legacy
 * o key relativa. Si VUE_APP_MEDIA_CDN_URL está definida, reescribe hosts S3
 * (p.ej. seminuevos-front-s3.s3.amazonaws.com) al CDN público.
 *
 * Ejemplo demos:
 *   https://seminuevos-front-s3.s3.amazonaws.com/cdn/100/973/imagenes/x.webp
 *   → https://pruebas.testgkytfsmx.com/cdn/100/973/imagenes/x.webp
 */

function mediaCdnOrigin(): string {
  const raw = (process.env.VUE_APP_MEDIA_CDN_URL || "").trim();
  if (!raw) {
    return "";
  }
  return raw.replace(/\/+$/, "");
}

function isS3MediaHost(hostname: string): boolean {
  // bucket.s3.amazonaws.com | bucket.s3.us-east-1.amazonaws.com | s3.amazonaws.com | s3.region.amazonaws.com
  return (
    /\.s3([.-][a-z0-9-]+)?\.amazonaws\.com$/i.test(hostname) ||
    /^s3([.-][a-z0-9-]+)?\.amazonaws\.com$/i.test(hostname)
  );
}

/**
 * Reescribe URL absoluta S3 → CDN. Si no hay CDN o no es S3, devuelve igual.
 * Paths relativos `/cdn/...` o `cdn/...` se absolutizan con el CDN cuando existe.
 */
export function rewriteMediaCdnUrl(value: string): string {
  const v = (value || "").trim();
  if (!v) {
    return "";
  }
  const cdn = mediaCdnOrigin();
  if (!cdn) {
    return v;
  }

  if (/^https?:\/\//i.test(v)) {
    try {
      const u = new URL(v);
      if (!isS3MediaHost(u.hostname)) {
        return v;
      }
      return `${cdn}${u.pathname}${u.search}${u.hash}`;
    } catch {
      return v;
    }
  }

  // Key o path de media en bucket (sin host)
  if (v.startsWith("/cdn/") || v.startsWith("cdn/")) {
    const path = v.startsWith("/") ? v : `/${v}`;
    return `${cdn}${path}`;
  }

  return v;
}

/**
 * Resuelve src de banner o portada: URL http(s), data URI o base64 legacy.
 */
export function resolveMediaSrc(value?: string | null, fallbackMime = "image/png"): string {
  if (!value || typeof value !== "string") {
    return "";
  }
  const v = value.trim();
  if (!v) {
    return "";
  }
  if (/^https?:\/\//i.test(v) || v.startsWith("/")) {
    return rewriteMediaCdnUrl(v);
  }
  if (v.startsWith("data:")) {
    return v;
  }
  if (v.startsWith("cdn/")) {
    return rewriteMediaCdnUrl(v);
  }
  return `data:${fallbackMime};base64,${v}`;
}
